<template lang="pug">
.subscription-menu.container
  transition( name='fade-fast' mode='out-in' )
    .row.success( v-if='confirmed' key='success' )
      h2 Success!
      div.welcome.col-12
        | You've succesfully signed up for the {{ currentLevel.name }} package.
        span( v-if='targetPost' )
          | You can now see the content you were trying to view
          router-link( :to='targetPost' ) here
    .confirm.container( v-else-if='selectedLevel' key='confirm' )
      h2.message Confirm Order
      b-table.order(
        striped
        hover
        :items='order'
        :fields='order_fields'
        stacked='sm'
      )
      .actions
        b-btn(
          class=`col-6 col-md-3 col-lg-2 submit confirm checkout paypal
                 paypal-express`
          @click.stop='getConfirmation'
          variant='warning'
        ) checkout
        b-btn.col-6.col-md-3.col-lg-2.cancel(
          @click.stop='unsetLevel'
          variant='link'
        ) go back
    .row( v-else key='select' )
      .description.col-12
        slot
      .col-12.col-md-4( v-for='level in memberLevels' :key='level.id' )
        b-card.member-level(
          no-body
          :class='{ current: currentLevel.id == level.id }'
          :header='level.name'
          @click='setLevel( level )'
        )
          b-card-body
            .description( v-html='level.description' )
            .price ${{ level.initial_payment || level.billing_amount }}
          b-card-footer.selected( v-if='currentLevel.id == level.id' )
            | expires {{ user.membership.expires }}
          b-card-footer.buy( v-else )
            //- router-link( :to=''/members/signup/' + level.id' )
            a( href='#' @click.stop='setLevel( level )' )
              | {{ user ? 'select' : 'sign up' }}
</template>

<script lang="js">
import _wpapix from '@/lib/wpapix'
import { User } from '@/mixins'

export default {
  name: 'subscription-menu',
  mixins: [ User ],
  components: {},
  props: {
    levels: {
      type: Array,
      default: () => []
    },
    target: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedLevel: false,
      storedLevels: false,
      wait: false,
      confirmed: false,
      fetching: false,
      order_fields: [
        {
          key: 'item',
          class: 'col-8'
        },
        {
          key: 'amount',
          label: 'Amount (USD)',
          class: 'col-4'
        }
      ],
      order: []
    }
  },
  created() {},
  mounted() {
    if ( !this.levels.length ) {
      _wpapix.then( wpapix => {
        var levels = new wpapix.Membership({ path: 'levels' })
        levels.fetch().done( res => {
          console.log( 'got membership levels', res )
          this.storedLevels = res
        })
      })
    }
  },
  methods: {
    setLevel( level ) {
      if ( !this.user ) {
        // TODO: redirect to login, then continue
      }
      if ( this.currentLevel && this.currentLevel.id === level.id ) {
        return
      }
      this.selectedLevel = level
      this.order = [
        { item: level.name, amount: level.billing_amount },
        {
          item: 'Total',
          amount: level.billing_amount,
          _rowVariant: 'secondary'
        }
      ]
    },
    unsetLevel() {
      this.selectedLevel = false
    },
    getConfirmation( e, level ) {
      window.open( '/members/checkout?level=' + this.selectedLevel.id +
                   '&submit-checkout=1&checkjavascript=1&javascriptok=1',
                   '_blank' )
      _wpapix.then( wpapix => {
        var membership = new wpapix.Membership({ path: 'my-level' })
        this.fetching = false
        this.wait = window.setInterval( () => {
          if ( this.fetching ) return
          this.fetching = true
          membership.fetch({
            success: ( model, res, opt ) => {
              if ( res && res.id !== this.currentLevel.id ) {
                this.confirmed = true
                this.user.membership = res
                window.clearInterval( this.wait )
                this.wait = false
                window.setTimeout( () => { this.fetching = false }, 250 )
              } else {
                this.fetching = false
              }
            },
            error: ( model, res, opt ) => {
              this.fetching = false
            }
          })
        }, 2500)
      })
    }
  },
  computed: {
    memberLevels() {
      return ( this.levels.length ? this.levels : this.storedLevels )
    },
    currentLevel() {
      return ( this.user && ( !this.user.as || this.user.as.subscriber ) &&
               this.user.membership ) || false
    },
    targetPost() { return this.target }
  }
}
</script>

<style lang="scss">
.subscription-menu {

}
</style>
